// Temporary redirect for emails and bookmarks created before the tax-binder rename.
// All /preparer/binders/* paths redirect to /preparer/tax-binders/* preserving the full path tail.
// Remove approximately 6 weeks after release (around 2026-06-15).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/binders/$')({
  beforeLoad: ({ params }) => {
    const tail = (params as Record<string, string>)['_splat'] ?? '';
    throw redirect({
      href: `/preparer/tax-binders/${tail}`,
      replace: true,
    });
  },
  component: () => null,
});
